import { S, ui } from "../../app/store.js";
import { ACCOUNTS } from "../../domain/reference.js";
import { P, esc, peso } from "../../domain/format.js";
import { siteCode } from "../sites/model.js";
import { chip } from "../../components/ui.js";

function jvForm() {
  const d = ui.jvDraft,
    opt = (v) =>
      ACCOUNTS.map(
        (a) =>
          `<option value="${a[0]}"${a[0] === v ? " selected" : ""}>${a[0]} ${esc(a[1])}</option>`,
      ).join("");
  const td = d.lines.reduce((a, l) => a + (+l.d || 0), 0),
    tc = d.lines.reduce((a, l) => a + (+l.c || 0), 0);
  return `<form class="panel" id="jvform"><h3>New journal voucher</h3>
   <div class="form"><label>Date<input type="date" id="jv-date" value="${d.date}"></label><label>Site / project<select id="jv-site"><option value="">Head office / unassigned</option>${S.projects.map((p) => `<option value="${esc(p.code)}"${d.project === p.code ? " selected" : ""}>${esc(siteCode(p))} · ${esc(p.code)} · ${esc(p.name)}</option>`).join("")}</select></label><label style="grid-column:span 2">Particulars<input id="jv-memo" value="${esc(d.memo)}" placeholder="e.g. Accrue October plant rent"></label></div>
   <div class="tbl"><table><thead><tr><th>Account</th><th class="n">Debit</th><th class="n">Credit</th></tr></thead><tbody>
   ${d.lines.map((l, i) => `<tr><td><select id="jv-a-${i}" data-i="${i}" data-f="a">${opt(l.a)}</select></td><td><input id="jv-d-${i}" data-i="${i}" data-f="d" inputmode="decimal" value="${l.d}" style="text-align:right;width:9rem"></td><td><input id="jv-c-${i}" data-i="${i}" data-f="c" inputmode="decimal" value="${l.c}" style="text-align:right;width:9rem"></td></tr>`).join("")}
   </tbody><tfoot><tr><td>Totals ${Math.abs(td - tc) < 0.005 && td > 0 ? chip("Balanced", "good") : chip("Not balanced", "bad")}</td><td class="n">${peso(P(td))}</td><td class="n">${peso(P(tc))}</td></tr></tfoot></table></div>
   ${ui.err ? `<p class="err">${esc(ui.err)}</p>` : ""}
   <div class="row"><button type="button" data-act="jv-line">Add line</button><button type="submit" class="pri">Save as draft for approval</button><button type="button" class="ghost" data-act="jv-cancel">Cancel</button></div></form>`;
}

function readJV() {
  const d = ui.jvDraft;
  if (!d) return;
  d.date = document.getElementById("jv-date").value;
  d.memo = document.getElementById("jv-memo").value;
  d.project = document.getElementById("jv-site").value;
  d.lines.forEach((l, i) => {
    l.a = document.getElementById("jv-a-" + i).value;
    l.d = document.getElementById("jv-d-" + i).value.replace(/,/g, "");
    l.c = document.getElementById("jv-c-" + i).value.replace(/,/g, "");
  });
}

export { jvForm, readJV };
